import { httpClient } from '../config';

// httpClient resolves with the error object on 4xx/5xx, so the response must be checked explicitly
const throwResponseError = (response, fallbackMessage) => {
  const error = new Error((response && response.message) || fallbackMessage);
  error.guards = response && response.body && response.body.guards;
  throw error;
};

export const fetchAdsActionGuards = async ({ id, industry_id }) => {
  const response = await httpClient(`/tables/ads_actions/${id}/guards?industry_id=${industry_id}`);
  if (!response || !response.json) throwResponseError(response, 'Failed to load guards');
  return response.json;
};

export const approveAdsAction = async ({ id, industry_id }) => {
  const response = await httpClient(`/tables/ads_actions/${id}/approve`, {
    method: 'POST',
    body: JSON.stringify({ industry_id }),
  });
  if (!response || !response.json) throwResponseError(response, 'Approve failed');
  return response.json;
};

export const rejectAdsAction = async ({ id, industry_id, reason }) => {
  const response = await httpClient(`/tables/ads_actions/${id}/reject`, {
    method: 'POST',
    body: JSON.stringify({ industry_id, reason }),
  });
  if (!response || !response.json) throwResponseError(response, 'Reject failed');
  return response.json;
};
